import { render, staticRenderFns } from "./jobComponent.vue?vue&type=template&id=a00f24f4&"
import script from "./jobComponent.vue?vue&type=script&lang=js&"
export * from "./jobComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports